import { render, staticRenderFns } from "./comp-user-name-setting.vue?vue&type=template&id=6f9550ea&scoped=true&lang=pug&"
import script from "./comp-user-name-setting.vue?vue&type=script&lang=js&"
export * from "./comp-user-name-setting.vue?vue&type=script&lang=js&"
import style0 from "./comp-user-name-setting.vue?vue&type=style&index=0&id=6f9550ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9550ea",
  null
  
)

export default component.exports